import React, { useState, useEffect,useContext } from "react";
import { MDBRow, MDBCol } from 'mdbreact';
import CustomMultiSelect from 'components/MultiSelect/MultiSelect';
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
const cookies = new Cookies();

function Step3(props) {
  let [optionValue, setoptionValue] = useState(props.block.options);
  const [wizardData, setWizardData] = useContext(WizardDataContext);
  useEffect(() => {
    (async () => {
      if(props.futurename === 'Role'){
        const getdrpdwnresponseJson = wizardData.productsView;;
        setoptionValue(getdrpdwnresponseJson.data.users);
      }
    })()
  }, [wizardData]);

  if (props.currentStep !== props.block.step) {
      return null
  } 
  return (
    <div>
      <MDBRow>
        <MDBCol md="4" className="mb-3">
          <CustomMultiSelect
            options={optionValue}
            changed = {chk => props.multiselection(chk)}
            selectChildValue={props.selectChildValue}
          />
        </MDBCol>
      </MDBRow>
  </div>
  )
}

export default Step3;
